import { useCallback } from 'react';
export var useCallLoadMore = function (loadMore, limit) {
    return useCallback(function () {
        if (loadMore) {
            loadMore(limit);
        }
    }, [limit, loadMore]);
};
